module.exports = {"513423100":"盐井镇","513423101":"卫城镇","513423102":"梅雨镇","513423103":"白乌镇","513423104":"树河镇","513423105":"黄草镇","513423106":"平川镇","513423107":"泸沽湖镇","513423108":"官地镇","513423200":"双河乡","513423202":"下海乡","513423203":"棉桠乡","513423204":"甘塘乡","513423206":"藤桥乡","513423207":"田湾乡","513423209":"大河乡","513423210":"盐塘乡","513423211":"巫木乡","513423212":"大草乡","513423213":"博大乡","513423214":"金河乡","513423215":"右所乡","513423218":"长柏乡","513423219":"桃子乡","513423220":"盖租乡","513423221":"前所乡","513423222":"沃底乡","513423223":"大坡蒙古族乡","513423224":"洼里乡","513423225":"梅子坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513423.json
// module id = 2246
// module chunks = 0